import { BACKEND } from "../variables";
import axios from "axios";

const GET_BY_HOUSE_URL = BACKEND + "/paymentTypes/getByHouse";
const CREATE_URL = BACKEND + "/paymentTypes/create";
const UPDATE_URL = BACKEND + "/paymentTypes/update";
const DELETE_URL = BACKEND + "/paymentTypes/delete";

const paymentTypes = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_PAYMENT_TYPES"]: (state, payload) => {
      return axios({
        url: GET_BY_HOUSE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CREATE_PAYMENT_TYPE"]: (state, payload) => {
      return axios({
        url: CREATE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_PAYMENT_TYPE"]: (state, payload) => {
      return axios({
        url: UPDATE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_PAYMENT_TYPE"]: (state, payload) => {
      return axios({
        url: DELETE_URL,
        method: "POST",
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
  modules: {},
};

export default paymentTypes;
